import {
  Box,
  Flex,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  Grid
} from "@chakra-ui/react";
import React, { memo, useState } from "react";
import { getDocData } from "./helper";
import { TableViewSharedDocCard } from "./TableViewSharedDocCard";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
} from "@dnd-kit/modifiers";
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { IoMdAddCircle } from "react-icons/io";
import LaunchdeckButton from "../../global/components/helper-components/components/LaunchdeckButton";

const TableViewSharedDocsList = ({
  isDsrAdmin,
  sharedDocsArray,
  showDeleteSpinner,
  showPopoverDocId,
  setShowPopoverDocId,
  handleSharedDocOrderChange,
  handleDeleteSharedDoc,
  handleClickAddDocumentButton,
  isRoomTemplate,
  handleEditSharedDoc,
  isOpen,
  onOpen,
  onClose,
}) => {

  const sensors = useSensors(useSensor(PointerSensor));
  const [activeId, setActiveId] = useState(null);

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event) => {
    setActiveId(null);
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const pagesIdArray = sharedDocsArray?.map(
        (docObject) => docObject?.docId,
      );

      const activeIndex = pagesIdArray.indexOf(active.id);
      const overIndex = pagesIdArray.indexOf(over.id);
      handleSharedDocOrderChange(activeIndex, overIndex, sharedDocsArray);
    }
  };


  return (
    <>
      <Flex
        w="100%"
        className="task-category-group-container"
        position='relative'
        justify="space-between"
        align="center"
        p="1em 1.5em"
      >
        <Box
          position='absolute'
          top='0.8em'
          right='1.5em'
          cursor='pointer'
          onClick={handleClickAddDocumentButton}
        >
          <LaunchdeckButton
            bg='brand.500'
            color='white'
            py='0.2em'
          >
            <Flex gap={4} align='center'>
              <IoMdAddCircle font-size='1.5em' />
              <Box fontSize='1em'>
                New
              </Box>
            </Flex>
          </LaunchdeckButton>
        </Box>

        <DndContext
          sensors={sensors}
          onDragEnd={handleDragEnd}
          onDragStart={handleDragStart}
          modifiers={[restrictToVerticalAxis]}
        >
          <TableContainer w="100%" fontSize="0.875em">
            <SortableContext
              items={sharedDocsArray?.map((docObject) => docObject?.docId)}
              strategy={verticalListSortingStrategy}
            >
              <Table size="2em">
                {/* <Thead>
                  <Tr>
                  <Th></Th>
                    {HEADERS.map((header) => <Th>{header}</Th>)}
                  </Tr>
                  <Th></Th>
                </Thead> */}

                <Thead>
                  <Tr>

                    <Th></Th> {/* Drag handle column */}
                    <Th>
                      <Grid templateColumns="3fr 1fr 1fr 1fr" gap={4}>
                        <Box>Name</Box>
                        <Box>Owner</Box>
                        <Box>Created</Box>
                      </Grid>
                    </Th>
                    <Th></Th> {/* Actions column */}

                  </Tr>
                </Thead>

                <Tbody>
                  {sharedDocsArray?.map((docObject) => {
                    const {
                      docId,
                      docName,
                      createdAt,
                      formattedDocLink,
                      memberName,
                      docDescription,
                      fileKey,
                    } = getDocData({ docObject });

                    return (
                      <TableViewSharedDocCard
                        isDsrAdmin={isRoomTemplate ? true : isDsrAdmin}
                        key={docId}
                        docId={docId}
                        docName={docName}
                        docSharedAt={createdAt}
                        docDescription={docDescription}
                        formattedDocLink={formattedDocLink}
                        memberName={isRoomTemplate ? "You" : memberName}
                        fileKey={fileKey}
                        showDeleteSpinner={showDeleteSpinner}
                        showPopoverDocId={showPopoverDocId}
                        setShowPopoverDocId={setShowPopoverDocId}
                        handleDeleteSharedDoc={handleDeleteSharedDoc}
                        handleEditSharedDoc={handleEditSharedDoc}
                        isOpen={isOpen}
                        onOpen={onOpen}
                        onClose={onClose}
                      />
                    );
                  })}
                </Tbody>
              </Table>

              <DragOverlay modifiers={[restrictToWindowEdges]}>
                {activeId ? <Skeleton height="20px" my="10px" /> : null}
              </DragOverlay>
            </SortableContext>
          </TableContainer>
        </DndContext>
      </Flex>
    </>
  );
};

const mapStateToProps = (state) => ({
  isRoomTemplate: state.dsrTemplateId.isRoomTemplate
})


export default memo(withRouter(connect(mapStateToProps, null)(TableViewSharedDocsList)))
